<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-address-card" main="Jobs" sub="Lista de Jobs disponíveis" />
        <!-- ACEITE -->
        <b-modal id="modal-aceite" hide-footer>
            <template v-slot:modal-title>
                Verifique os dados do Serviço:
            </template>
            <div class="d-block text-center">
                <p><b>Número do Processo: </b>{{ job.numero }}</p>
                <p><b>Descrição: </b>{{ job.descricao }}</p>
                <p><b>Categoria: </b>{{ job.categoria_titulo }}</p>
                <p><b>Subcategoria: </b>{{ job.subcategoria_titulo }}</p>
                <p><b>Tipo de Serviço: </b>{{ job.id_tiposervico_titulo }}</p>
                <p><b>Data de publicação: </b>{{ job.dataPublicacao }}</p>
                <p><b>Prazo: </b>{{ job.id_tiposervico_prazo }} dias</p>
                <hr>
                <p><b>Quem publicou: </b>{{ job.quemPublicou_nome }}</p>
                <p><b>Data da postagem: </b>{{ job.dataPostagem }}</p>
                <hr>
                <p><b>UF: </b>{{ job.uf }}</p>
                <p><b>Cidade: </b>{{ job.cidade }}</p>
                <p><b>Vara: </b>{{ job.vara }}</p>
                <hr>
                <p><b>Segredo de Justiça: </b>{{ job.segredoJustica }}</p>
                <hr>
                <p><b>Status: </b>{{ job.status }}</p>
                <hr>
                <p><b>Anexos: </b>Caso deseje visualizar os anexos, aceite o job.</p>
            </div>
            <b-button variant="success" class="mt-3" block @click="setAceite">Confirmar Serviço</b-button>
            <b-button variant="danger" class="mt-3" block @click="$bvModal.hide('modal-aceite')">Cancelar</b-button>
        </b-modal>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(servico)="data">
                    {{ data.item.categoria_titulo }}->{{ data.item.subcategoria_titulo }}->{{ data.item.id_tiposervico_titulo }}
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1" @click="openAceite(data.item)" 
                        v-if="data.item.status==='AGUARDANDO ACEITE' && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='prestador')">
                        <font-awesome-icon :icon="['fa', 'check']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(servico)="data">
                    {{ data.item.categoria_titulo }}->{{ data.item.subcategoria_titulo }}->{{ data.item.id_tiposervico_titulo }}
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1" @click="openAceite(data.item)" 
                        v-if="data.item.status==='AGUARDANDO ACEITE' && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='prestador')">
                        <font-awesome-icon :icon="['fa', 'check']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'jobs',
    components: { PageTitle },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nivel: '',
            job: {},
            jobs: [],
            aceite: {},
            quemRecebeu: '',
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'numero', label: 'Número', sortable: true },
                { key: 'servico', label: 'Serviço', sortable: true },
                { key: 'dataPublicacao', label: 'Data de Publicação', sortable: true, formatter: 'formatData' },
                { key: 'id_tiposervico_datavalidade', label: 'Data Limite', sortable: true, formatter: 'formatData' },
                { key: 'segredoJustica', label: 'Segredo de Justiça', sortable: true },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' }  }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        rows() {
            return this.jobs.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        openAceite(job) {
            this.job = job
            this.$bvModal.show('modal-aceite')
        },
        setAceite() {
            this.aceite.id = this.job.id
            this.aceite.quemRecebeu = this.quemRecebeu
            axios['put'](`${baseApiUrl}/backend/GENERAL/aceitaJob.php?id=${this.aceite.id}`, this.aceite)
            .then(() => {
                this.$bvModal.hide('modal-aceite')
                this.$toasted.global.defaultSuccess({ message : 'Serviço aceito com sucesso!' })
                this.reset()
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadJobs() {
            const url = `${baseApiUrl}/backend/SELECT/jobs.php`
            axios.get(url).then(res => {
                this.jobs = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            })
        },
        reset() {
            this.job = {}
            this.loadJobs()
        },
        loadJob(job) {
            this.job = { ...job }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel === 'fornecedor') {
            this.$router.push('/')
        }
        this.loadJobs()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.jobs.length

    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.text-custom {
    font-size: 0.8rem;
}
</style>